import Vue from "vue";
import {TextToCode} from "element-china-area-data";

const gFunc = {
    deepValue(item, options, _listindex) {
        // console.log('getvalue');
        // console.log(item, options, _listindex);
        try {
            let valList = options.split(".");
            if (valList.length > 1) {
                let val = "";
                for (let index = 0; index < valList.length; index++) {
                    if (index === 0) {
                        val = item[valList[index]];
                    } else {
                        if (valList[index] === '*') {
                            if (_listindex !== undefined) {
                                val = val[_listindex];
                            } else {
                                break;
                            }
                        } else {
                            val = val[valList[index]];
                        }
                    }
                }
                return val;
            } else {
                return item[options];
            }
        } catch (error) {
            // eslint-disable-next-line
            console.error(error);
        }
    },
    formatNumber(val) {//格式化数据
        // console.log();
        if (val > 3) {
            let newNum = Number(val).toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
            newNum = newNum.substring(0, newNum.indexOf("."));
            return newNum;
        }
        return val;
    },
    /**
     * local storage set
     * @param name
     * @param value
     * @param expire
     */
    lsSet(name, value, expire = 60 * 60 * 24 * 1000) {
        Vue.ls.set(name, value, expire);
    },
    /**
     * 省市区 转 CODE
     * @param province
     * @param city
     * @param area
     * @returns {*[]}
     */
    regionToCode(province = false, city = false, area = false) {
        if (TextToCode[province] && TextToCode[province].code) {
            if (province && city && TextToCode[province][city]) {
                if (area && TextToCode[province][city][area])
                    return [TextToCode[province].code, TextToCode[province][city].code, TextToCode[province][city][area].code]
                else
                    return [TextToCode[province].code, TextToCode[province][city].code,]
            }
        }
        return [];
    },
    /**
     * Parse the time to string
     * @param {(Object|string|number)} time
     * @param {string} cFormat
     * @returns {string | null}
     */
    parseTime(time, cFormat) {
        if (arguments.length === 0) {
            return null
        }
        const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
            date = time
        } else {
            if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
                time = parseInt(time)
            }
            if ((typeof time === 'number') && (time.toString().length === 10)) {
                time = time * 1000
            }
            date = new Date(time)
        }
        const formatObj = {
            y: date.getFullYear(),
            m: date.getMonth() + 1,
            d: date.getDate(),
            h: date.getHours(),
            i: date.getMinutes(),
            s: date.getSeconds(),
            a: date.getDay()
        }
        return format.replace(/{([ymdhisa])+}/g, (result, key) => {
            const value = formatObj[key]
            // Note: getDay() returns 0 on Sunday
            if (key === 'a') {
                return ['日', '一', '二', '三', '四', '五', '六'][value]
            }
            return value.toString().padStart(2, '0')
        })
    },
    /**
     * 数字格式化
     * @param number
     * @param decimals
     * @param decPoint
     * @param thousandsSep
     * @param roundtag
     * @returns {string}
     */
    numberFormat(number, decimals, decPoint, thousandsSep, roundtag) {
        /*
        * 参数说明：
        * number：要格式化的数字
        * decimals：保留几位小数
        * dec_point：小数点符号
        * thousands_sep：千分位符号
        * roundtag:舍入参数，默认 'ceil' 向上取,'floor'向下取,'round' 四舍五入
        * */
        number = (number + '').replace(/[^0-9+-Ee.]/g, '')
        roundtag = roundtag || 'round' // 'ceil','floor','round'
        var n = !isFinite(+number) ? 0 : +number
        var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
        var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
        var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
        var s = ''
        var toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec)
            return '' + parseFloat(Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)) / k
        }
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
        var re = /(-?\d+)(\d{3})/
        while (re.test(s[0])) {
            s[0] = s[0].replace(re, '$1' + sep + '$2')
        }

        if ((s[1] || '').length < prec) {
            s[1] = s[1] || ''
            s[1] += new Array(prec - s[1].length + 1).join('0')
        }
        return s.join(dec)
    }
}

export {gFunc}
